
import React from 'react';
import { Globe } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface DomainSettingsTabProps {
  onSaveSettings: (section: string) => void;
}

const DomainSettingsTab: React.FC<DomainSettingsTabProps> = ({ onSaveSettings }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Domain Configuration</CardTitle>
        <CardDescription>
          Configure domain settings and allowlists
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="baseDomain">Base Domain</Label>
          <Input 
            id="baseDomain" 
            defaultValue="referme.site" 
            placeholder="Base Domain" 
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="allowCustomDomains">Allow Custom Domains</Label>
          <div className="flex items-center space-x-2">
            <Switch id="allowCustomDomains" defaultChecked />
            <span>Enable custom domain support for businesses</span>
          </div>
        </div>
        
        <div className="pt-4">
          <Button onClick={() => onSaveSettings('Domain')}>
            Save Domain Settings
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DomainSettingsTab;
